import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AppComponent } from 'src/app/app.component';
import { GetHotelInfoResp } from 'src/app/models/Pacchetti';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-gallery-hotel',
  templateUrl: './gallery-hotel.component.html',
  styleUrls: ['./gallery-hotel.component.scss']
})
export class GalleryHotelComponent implements OnInit {
  public hotelGallery: GetHotelInfoResp;

  constructor(@Inject(MAT_DIALOG_DATA) private _data: any,
    public dialogRef: MatDialogRef<GalleryHotelComponent>,
    public sanitizer: DomSanitizer,
    public app: AppComponent) {
    this.hotelGallery = _data;
  }

  ngOnInit(): void {
  }

  sanitize(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public sanitizeImage(image: string) {
    const url = AppSettings.URL;
    if (image.startsWith('img/'))
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}/${image}')`);
    else
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}/img/${this.app.store}/${image}')`);
  }

  getSource(image: string): string {
    if (image.startsWith('img/'))
      return AppSettings.URL + '/' + image;
    else
      return AppSettings.URL + '/img/' + this.app.store + '/' + image;
  }

}
